const emailPattern =
	/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const noCharsPattern = /[aA-zZ\.\+\_\-\)\(\*\&\^\%\$\@\!\=\`\~\|\\\]\[\"\:\;\<\?]/g

export function validate(cmd, value) {
	if (value == null) return false
	if (cmd === 'email') {
		// remove empty spaces at end of email
		const mail = value.trim()
		if (!mail.match(emailPattern)) return false
	}

	if (cmd === 'input') {
		if (!value) return false
	}

	if (cmd === 'numbers') {
		if (value.match(noCharsPattern)) return false
	}

	if (cmd === 'phone') {
		value = value.replace(/\s/g, '')
		if (value.match(noCharsPattern)) return false
		if (value.length != 10) return false
	}
	return true
}
